module.exports = __webpack_public_path__ + "img/364.7c062e2d.png";